@if (!loading && showRecommendations) {
    <app-more-like-this [userCompletions]="userCompletions" [objectId]="latestCompletion?.id" [title]="latestCompletion?.name"></app-more-like-this>
}
@else if (loading) {
    <app-spinner></app-spinner>
}
